import { render, staticRenderFns } from "./ProfileQualificationRequirementGroup.vue?vue&type=template&id=2faddbce&"
import script from "./ProfileQualificationRequirementGroup.vue?vue&type=script&lang=js&"
export * from "./ProfileQualificationRequirementGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports